export default __webpack_public_path__ + "static/media/people-blue.684a13b7.svg";